import { NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import ServiceProviderApiClient from '../../../Maintenance/ApiClients/ServiceProviderApiClient';
import ExcludedAccountLookup from '../Models/Lookups/ExcludedAccountLookup';

@NeoModel
export default class ManageExclusionAccountsComponentVM extends Views.ViewModelBase {

    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {
        super(taskRunner);
    }

    public managedExclusionAccount = new ExcludedAccountLookup();

    public async initialise() {
    }

}